import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const hotelGallery = () => {
  jQuery(document).ready(function($) {
    const body = $('body');

    // Hotel gallery modal
    const hotelGalleryModal = $('.hotel-gallery-modal');
    if (hotelGalleryModal.length) {
      $(document).on('click', '.hotel-gallery-trigger', function(e) {
        e.preventDefault();

        const _this = $(this);
        const url = _this.attr('href');
        const title = _this.data('title');
        const virtualTour = _this.data('virtual-tour');
        const hotelGalleryInnerContent = hotelGalleryModal.find('.hotel-gallery-inner-content');
        const iframe = hotelGalleryInnerContent.find('iframe');

        helpers.pushStateHistory(url, true);
        body.addClass('hotel-gallery-mode');
        helpers.stopBodyScrolling(true);

        $(document).trigger(constants.EVENT_VIRTUAL_PAGEVIEW, [url, title]);

        if (!hotelGalleryModal.hasClass('loaded')) {
          hotelGalleryInnerContent.load(('' + url + ' .hotel-gallery-inner-sections'), function () {
            $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);

            if (virtualTour) {
              const navLink = $('.nav a.nav-link[href="#hotel-gallery-virtual-tour"]');

              if (navLink.length) {
                navLink.tab('show');
              }
            }

            hotelGalleryModal.addClass('loaded');
          });
        }

        if (iframe.length) {
          iframe.attr('src', iframe.attr('data-src'));
        }
      });

      $(document).on('click', '.hotel-gallery-close', function(e) {
        e.preventDefault();

        const _this = $(this);
        const url = _this.attr('href');
        const title = _this.data('title');
        const hotelGalleryInnerContent = hotelGalleryModal.find('.hotel-gallery-inner-content');
        const iframe = hotelGalleryInnerContent.find('iframe');

        if (iframe.length) {
          iframe.attr('data-src', iframe.attr('src'));
          iframe.attr('src', '');
        }

        $(document).trigger(constants.EVENT_VIRTUAL_PAGEVIEW, [url, title]);

        helpers.stopBodyScrolling(false);
        helpers.pushStateHistory(url, true);
        body.removeClass('hotel-gallery-mode');
      });
    }
  });
};

export default hotelGallery;



// WEBPACK FOOTER //
// ./scripts/routes/modules/hotelGallery.js